import { h, ComponentChildren } from 'preact';

const resetStyle: h.JSX.CSSProperties = {
  display: 'block',
  WebkitAppearance: 'none',
  background: 'none',
  border: 'none',
  padding: 0,
  font: 'inherit',
  color: 'inherit',
  cursor: 'pointer'
};

type Props = Omit<h.JSX.HTMLAttributes<HTMLButtonElement>, 'type' | 'style'> & {
  style?: h.JSX.CSSProperties;
  children?: ComponentChildren;
};

export function ButtonBase({ style, children, ...props }: Props) {
  return (
    <button type="button" style={{ ...resetStyle, ...style }} {...props}>
      {children}
    </button>
  );
}
